/* unplugin-vue-components disabled */import { render } from "./source-tag.vue?vue&type=template&id=a26e8fa2&scoped=true"
import script from "./source-tag.vue?vue&type=script&lang=js"
export * from "./source-tag.vue?vue&type=script&lang=js"

import "./source-tag.vue?vue&type=style&index=0&id=a26e8fa2&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a26e8fa2"],['__file',"src/components/sources/source-tag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a26e8fa2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a26e8fa2', __exports__)) {
    api.reload('a26e8fa2', __exports__)
  }
  
  module.hot.accept("./source-tag.vue?vue&type=template&id=a26e8fa2&scoped=true", () => {
    api.rerender('a26e8fa2', render)
  })

}


export default __exports__